// extracted by mini-css-extract-plugin
export var button = "PayIdStep-module--button--381c1";
export var buttonContainer = "PayIdStep-module--buttonContainer--ad562";
export var buttonSkeleton = "PayIdStep-module--buttonSkeleton--7f329";
export var description = "PayIdStep-module--description--1f267";
export var descriptionSkeleton = "PayIdStep-module--descriptionSkeleton--056fb";
export var inputSkeleton = "PayIdStep-module--inputSkeleton--181d1";
export var skeleton = "PayIdStep-module--skeleton--59a22";